import {Injectable} from '@angular/core';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {UmpireOttEvent} from '@tisa-group/models';
import {LoadEvent} from './event.actions';
import {patch} from '@ngxs/store/operators';
import {OttEventService} from '@tisa-group/core/api/umpire';
import {Observable, tap} from 'rxjs';
import {JsonApiResponse} from '@tisa-group/cdk';

export type EventStateModel = Record<string, JsonApiResponse<UmpireOttEvent>>;

@State<EventStateModel>({
  name: 'Event',
  defaults: {},
})
@Injectable()
export class EventState {
  @Action(LoadEvent)
  loadEvent(
    ctx: StateContext<EventStateModel>,
    action: LoadEvent,
  ): Observable<JsonApiResponse<UmpireOttEvent>> | JsonApiResponse<UmpireOttEvent> {
    const stateEvent = ctx.getState()[action.slug];

    if (stateEvent && stateEvent.data?.stream?.manifests?.hls) {
      return stateEvent;
    }

    return this.eventService
      .fetch(action.slug, {
        include: [
          'tags',
          'image',
          'format',
          'segment',
          'image_horizontal',
          'image_vertical',
          'prices',
        ].join(','),
      })
      .pipe(
        tap(res =>
          ctx.setState(
            patch({
              [res.data.slug as string]: res,
            }),
          ),
        ),
      );
  }

  static getEventBySlug(
    slug: string,
  ): (state: EventStateModel) => JsonApiResponse<UmpireOttEvent> {
    return createSelector<(state: EventStateModel) => JsonApiResponse<UmpireOttEvent>>(
      [EventState],
      state => {
        return state[slug];
      },
    );
  }

  constructor(readonly eventService: OttEventService) {}
}
